import React from "react";
import { useUserContext } from "context/UserContext";
import MembershipAnalysisBK from "layouts/BK/membershipAnalysis";
import { normalizeRoleLevel } from "utils/roleUtils";

function MembershipAnalysis() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (numericRoleLevel === 1 || numericRoleLevel === 2) {
    return <MembershipAnalysisBK />;
  }
  return null;
}

export default MembershipAnalysis;
